import React from 'react'
import { format } from 'date-fns';
import { DatePicker, ConfigProvider } from 'antd';
import ptBR from 'antd/locale/pt_BR';
import 'dayjs/locale/pt-br';

const { RangePicker } = DatePicker;

export default function RangePickerComponent(props) {
    const { setFormData, disabled, fieldId } = props

    return (
        <ConfigProvider locale={ptBR}>
            <RangePicker
                disabled={disabled}
                variant='outlined'
                format='DD-MMMM-YYYY'
                placeholder={['Data inicial', 'Data final']}
                onChange={(e) => {
                    setFormData((prev) => ({
                        ...prev, [fieldId]: {
                            startDate: format(e[0]?.$d, 'yyyy-MM-dd'),
                            endDate: format(e[1]?.$d, 'yyyy-MM-dd'),
                        }
                    }))
                }} size='middle'
            />
        </ConfigProvider>
    )
}